import { api, makeApiRequest } from 'api/_init'
import { unwrapEnvelope } from 'domain/shared/envelope'
import { mapGoogleCallToActionsResponse } from './mappers'

// Google-scoped, per the v3->v4 migration guide's §6.1 (Call to action).
// The guide's own text writes this as `/connect/google/assets/call_to_actions`,
// but every other real `connect/google/assets/*` endpoint already
// implemented in this codebase (googleAudiences, googleConversionGoals,
// integrationAssets) lives under the `/integrations` prefix — the guide is
// inconsistent about including that prefix in its literal URL strings
// throughout, not just here. This follows the established real pattern.
// Confirmed live: the endpoint 400s with error.connect.google.missing_campaign_type
// without campaign_type — not mentioned in the guide's §6.1 params list, but
// required in practice. Expects the same API-mapped values as
// platform_overrides.google.campaign_type ('DISPLAY' | 'VIDEO_CONVERSIONS',
// see campaignType.js's toApiCampaignType) — pass that, not the UI-level
// GoogleCampaignType value.
const googleCallToActionsApi = {
  fetchCallToActionsAsync: async (goal, hasPixel, leadFormId, campaignType) => {
    const params = new URLSearchParams()
    if (goal) params.append('goal', goal)
    if (hasPixel != null) params.append('has_pixel', hasPixel)
    if (leadFormId != null) params.append('lead_form_id', leadFormId)
    if (campaignType) params.append('campaign_type', campaignType)

    const endpoint = `/integrations/connect/google/assets/call_to_actions?${params.toString()}`
    const response = await makeApiRequest(api, 'get', endpoint)
    const { data, error, status } = unwrapEnvelope(response)
    if (status === 200) {
      return { data: mapGoogleCallToActionsResponse(data), status }
    }
    return { error, status }
  },
}

export default googleCallToActionsApi
